import { ErrorHandler } from '@angular/core';

export class PWErrorHandler extends ErrorHandler {
  handleError(error: any) {
    super.handleError(error);

    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(error.message)) {
      alert('Sorry app needs reload to fetch chunk data');
      window.location.reload();
    }
  }
}
